// extracted by mini-css-extract-plugin
export default {"root":"_1xYf5","headline":"kCzGX"};